import { useEffect, useRef } from 'react';

type Func = () => any;

const useDidMountEffect = (func: Func, deps: any[]): void => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

export default useDidMountEffect;
